import {Button, Col, Image} from "antd";
import {fallbackImg} from "../../../../shared/constants/constants";
import "../../../styles/publications.css";

export const ActionButton = ({onClick, loading, icon}) => {

  return(
    <Col>
      <Button
        type={"text"}
        onClick={onClick}
        loading={loading}
        className={"action-buttons"}
      >
        <Image
          alt={"action"}
          style={{height: "24px"}}
          className={"action-buttons-icons"}
          src={icon}
          preview={false}
          fallback={fallbackImg}
        />
      </Button>
    </Col>
  );
};